/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Popover, theme, ModalConfirm } from "@nordcloud/gnui";
import { SUCCESS_TEXT } from "~/constants";
import { useRemoveEnvironment } from "~/hooks/graphql";
import { showSuccess } from "~/services/toast";
import { generateActionConfirmText, handleError } from "~/tools";
import { EnvironmentPopoverProps } from "./types";

export function EnvironmentPopover(props: EnvironmentPopoverProps) {
  const [isModalConfirmOpen, setIsModalConfirmOpen] = React.useState(false);

  const [removeEnvironment] = useRemoveEnvironment();

  const navigate = useNavigate();

  const onRemoveHandler = async (nid: string) => {
    try {
      await removeEnvironment({ nid });

      setIsModalConfirmOpen(false);
      showSuccess(SUCCESS_TEXT.environmentRemoved);
      navigate(`/applications/${props.applicationId}`);
    } catch {
      handleError({
        name: "envRemoveError",
        message:
          "Something went wrong. Enviroments with assigned estate records cannot be removed",
      });
    }
  };

  return (
    <>
      <Popover alignRight trigger={<Button severity="low" icon="menu" />}>
        <Button
          iconRight
          severity="low"
          css={{ backgroundColor: theme.color.background.ui01 }}
          icon="trash"
          onClick={() => setIsModalConfirmOpen(true)}
        >
          Delete Environment
        </Button>
      </Popover>
      <ModalConfirm
        isOpen={isModalConfirmOpen}
        actionLabel="Delete"
        contentLabel="Delete Environment"
        confirm={() => onRemoveHandler(props.nid)}
        onClose={() => setIsModalConfirmOpen(false)}
      >
        {generateActionConfirmText(props.name)("delete")()}
      </ModalConfirm>
    </>
  );
}
